import { Icon } from "~components/ui";
import { Button } from "./button";
import { useFilterEvents } from "./filter-events-context-provider";
import { useSectionEventTranslations } from "./translations-section-events-context-provider";

function ButtonClearAllFilters() {
  const { t } = useSectionEventTranslations();
  const { selectedFilters, clearAllFilters } = useFilterEvents();
  const hasFilters =
    selectedFilters.attendance.size > 0 ||
    selectedFilters.eventTypes.size > 0 ||
    selectedFilters.countries.size > 0;

  return hasFilters ? (
    <Button
      className="t-default-sm flex items-center gap-[2px] text-secondaryButton-text underline"
      onClick={() => clearAllFilters()}
    >
      <Icon weight="bold" size="12" name="X" />
      <span>{t.clearAll}</span>
    </Button>
  ) : null;
}

export { ButtonClearAllFilters };
